import { useEffect } from 'react';

import { FILTER_CONFIG } from 'config/filters';
import useAppDispatch from 'hooks/common/useAppDispatch';
import useAppSelector from 'hooks/common/useAppSelector';
import { selectIsUserSupport } from 'redux/selectors';
import { initVisibleFilters } from 'redux/slices/staff/visibleFiltersSlice';

export const useInitPageFilters = (page: keyof typeof FILTER_CONFIG) => {
  const dispatch = useAppDispatch();
  const isSupport = useAppSelector(selectIsUserSupport);
  const currentFilters = useAppSelector(state => state.visibleFilters[page]);

  useEffect(() => {
    if (!currentFilters) {
      const config = FILTER_CONFIG[page];
      dispatch(
        initVisibleFilters({
          page,
          allFilters: config.allFilters,
          isSupport,
          supportExcluded: config.supportExcluded,
        })
      );
    }
  }, [dispatch, page, isSupport, currentFilters]);
};
